import React from "react";
import { Formik } from "formik";
import { Col, Button, Form, Spinner } from "react-bootstrap";
import * as Yup from "yup";

const ActionForm = ({
  onSubmit,
  attendanceYear,
  attendanceMonth,
}) => {
  const getMonthOptions = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months.map((month, index) => (
      <option key={index} value={index+1}>
        {month}
      </option>
    ));
  };

  const validationSchema = Yup.object().shape({
    year: Yup.string().required("Please select a year"),
    month: Yup.string().required("Please select a month"),
  });

  return (
    <Formik
      initialValues={{
        year: attendanceYear,
        month: attendanceMonth,
      }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ values, handleChange, handleSubmit, touched, errors, isSubmitting }) => (
        <Form noValidate onSubmit={handleSubmit} className="row mb-3">
          <Col xs={4}>
            <Form.Group controlId="year">
              <Form.Control
                as="select"
                name="year"
                className="shadow-none border border-1 text-center"
                isInvalid={touched.year && !!errors.year}
                value={values.year}
                onChange={handleChange}
                disabled={isSubmitting}
              >
                <option value=""> -- Select Year --</option>
                <option value={2023}>2023</option>
                <option value={2024}>2024</option>
                <option value={2025}>2025</option>
                <option value={2026}>2026</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.year}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={4}>
            <Form.Group controlId="month">
              <Form.Control
                as="select"
                name="month"
                className="shadow-none border border-1 text-center"
                isInvalid={touched.month && !!errors.month}
                value={values.month}
                onChange={handleChange}
                disabled={isSubmitting}
              >
                <option value=""> -- Select Month --</option>
                {getMonthOptions()}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.month}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={4}>
            <Button variant="primary" className="w-100" type="submit" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                    role="status"
                    className="me-2"
                    style={{ width: "18px", height: "18px" }}
                  />
                  Applying...
                </>
              ) : (
                "Apply"
              )}
            </Button>
          </Col>
        </Form>
      )}
    </Formik>
  );
};

export default ActionForm;
